import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { UserRepositoryBase } from '@skylab-shared/business';
export { UserRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(UserRepositoryBase)
export class UserRepository {
    public constructor(
        http: Http,
        weaver: Weaver
    ) { }
}
